import { useMemo } from 'react'

import { CategorySummaryData, getCategoryPath } from '@rewardops/utils'

export const useCategoriesWithUrls = (
  showProducts: string[] | undefined,
  categories: CategorySummaryData[] | undefined,
  roRootCategory: string,
  locale: string,
) => {
  return useMemo(() => {
    return categories
      ?.filter((category) => category.code !== roRootCategory)
      .map((category) => ({
        category,
        categoryUrl: getCategoryUrl(showProducts, category, locale),
      }))
  }, [categories, showProducts, roRootCategory])
}

const getCategoryUrl = (
  showProducts: string[] | undefined,
  category: CategorySummaryData,
  locale: string,
): string => {
  const pathWithItems =
    !showProducts ||
    showProducts.length === 0 ||
    showProducts.find((x: string) => category.code === x.trim())
  return pathWithItems
    ? `/items/${getCategoryPath(category, locale)}`
    : `/category/${getCategoryPath(category, locale)}`
}
